import fetchTotalDocumentsBySectionBuilder from '@/usecases/client/stats/fetchTotalDocumentsBySection';
import statsRepository from '@/repositories/client/stats';

export default {
  fetchTotalDocumentsBySection: fetchTotalDocumentsBySectionBuilder({ statsRepository }),
};
